import { useEffect, useState, useCallback } from 'react';

export const useGet = (url) => {
  const [apiResponse, setApiResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApiResponse = async () => {
      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Request failed with status: ${response.status}`);
        }

        const json = await response.json();

        setApiResponse(json);
        setLoading(false);
      } catch (error) {
        setError(
          error.message || 'An error occurred while fetching apiResponse.'
        );
        setLoading(false);
      }
    };

    fetchApiResponse();
  }, [url]);

  return { loading, error, apiResponse };
};

export const usePost = (url, data, redirectUrl) => {
  const [apiResponse, setApiResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const post = useCallback(
    async (data, redirectUrl) => {
      try {
        setLoading(true);

        const headers = {
          'Content-Type': 'application/json',
          TestMode: process.env.REACT_APP_WEBHOOK_MODE,
          Authorization: `Basic ${btoa(
            `skbv:${process.env.REACT_APP_WEBHOOK_PASSWORD}`
          )}`,
        };

        const response = await fetch(url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data),
        });

        const json = await response.json();
        if (response.status === 200) {
          window.location = redirectUrl;
        } else {
          setError('An error occurred posting form data.');
        }

        setApiResponse(json);
        setLoading(false);
      } catch (error) {
        setError(error.message || 'An error occurred posting form data.');
        setLoading(false);
      }
    },
    [url]
  );

  return { apiResponse, loading, error, post };
};
